import { twMerge } from "tailwind-merge";

import { useGetProfile } from "@/api/bale";
import { profileAvatarUrl, profileDisplayName } from "@/model/profile";

export function Avatar({ accountId, className }: { accountId: string; className?: string }) {
  const profile = useGetProfile(accountId, { query: { select: (data) => data.data.profile } });

  return (
    <div className={twMerge("size-12 shrink-0 overflow-hidden rounded-full bg-water", className)}>
      {profile.data && (
        <img
          src={profileAvatarUrl(profile.data)}
          alt={profileDisplayName(profile.data)}
          className="size-full object-contain"
        />
      )}
    </div>
  );
}
